export async function hasPermission(hoaID, permissionName) {
  const { token } = this.getToken()
  if (token == null) return false

  console.log('in hasPermission..................')

  //
  const decodedToken = JSON.parse(atob(token.split('.')[1]))
  //

  console.log('decodedToken=' + JSON.stringify(decodedToken))

  const permissions = decodedToken['khoala-claim:permissions']
  let permissionSet = false

  permissions.split(';').forEach(hoaPermissions => {
    let [currentHoaID, permissionList] = hoaPermissions.split(':')

    console.log('permissionsList=' + JSON.stringify(permissionList))

    if (currentHoaID == hoaID) {
      permissionSet = permissionList.split(',').includes(permissionName)
    }
  })

  console.log('checking ' + hoaID + ':' + permissionName + ' = ' + permissionSet)
  //
  return permissionSet
}
